import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {Subject, takeUntil} from 'rxjs';
import {SeFeButtonModule} from 'se-fe-button';
import {SeFeCardModule} from 'se-fe-card';
import {SeFeEmptyStateModule} from 'se-fe-empty-state';
import {SeFeGridModule} from 'se-fe-grid';
import {SeFeHeaderModule} from 'se-fe-header';
import {SeFeIconModule} from 'se-fe-icon';
import {SeFePageModule} from 'se-fe-page';
import {defaultProductQueryParams} from '../../../models';
import {selectClareAccountStatus} from '../../product-list/store/product-list.selectors';

@Component({
  selector: 'clare-onboarding',
  imports: [
    SeFeButtonModule,
    SeFeGridModule,
    SeFeIconModule,
    SeFeCardModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeEmptyStateModule,
  ],
  templateUrl: './clare-onboarding.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../product/components/create-product/create-product.component.scss',
})
export class ClareOnboardingComponent implements OnInit, OnDestroy {
  readonly onDestroy = new Subject<void>();
  status: string;
  organizationId: number;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.organizationId = Number(this.route.snapshot.paramMap.get('currentOrgId'));
    this.store
      .select(selectClareAccountStatus)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(status => {
        this.status = status;
        const params = defaultProductQueryParams();
        if (status === 'Complete') {
          this.router.navigateByUrl(
            `org/${this.organizationId}/commerce/products?page=${params.page}&take=${params.take}`
          );
        }
      });
  }
  ngOnDestroy(): void {
    this.onDestroy.complete();
  }

  navToFinancials() {
    if (window.parent && window.top) {
      const orgId = this.route.snapshot.paramMap.get('currentOrgId');
      const event = {
        type: 'FrameRouter:NavigateTop',
        data: {title: '', url: `/org/${orgId}/financial_settings/onboarding`, replace: true},
      };
      window.parent.postMessage(event, '*');
    }
  }
}
